import VTableCard from '@/vuetify_custom/v-table-card'
import VRippleCol from '@/vuetify_custom/v-ripple-col';
import ViewerItem from '@/views/components/viewer/item_v1.vue';
import { VSpacer } from 'vuetify/lib'
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        target: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        tableCardFields() {
            return [
                {
                    key: 'contracts'
                  },
                 {
                   label: '备注',
                   key: 'desc'
                 },
            ]
        }
    },
    render() {
        const _this = this
        return <VTableCard 
                    sub-title="补充信息"
                    value={_this.target}
                    fields={_this.tableCardFields}
               
                    scopedSlots={{
                        contracts({ value}) {
                            const contracts = value.contracts
                            if (!contracts || !contracts.length) {
                                return ''
                            }
                            return <div style={{width: '100%'}}>
                                  <VRippleCol cols={12}></VRippleCol>
                                    <VRippleCol cols={12}>
                                    <span style="white-space:nowrap">关联合同</span>
                                        <VSpacer/>
                                   </VRippleCol>   
                            { 
                            contracts.map(child => {
                                return <VRippleCol>
                                    <span style="white-space:nowrap">
                                        
                                        <ViewerItem
                                            type='Contract'
                                            modelId={child.id}
                                        >
                                            <span class="link">{child.uid }</span>
                                        </ViewerItem>
                                    </span>
                                    <VSpacer/>
                                    <p style={{
                                        marginLeft:"10px"
                                    }}>[{child.name}]</p>
                                </VRippleCol>
                              
                            })}
                            </div> 
                           
                            
                        }
                    }}
                />
    }
}